const languageArray = ['vi', 'en'];

export default languageArray;